const evite = window.evite = window.evite || {};
const experiments = evite.experiments = evite.experiments || {};

export function setExperiment(experimentName, value) {
  experiments[experimentName.toUpperCase()] = value;
}

export function getExperiment(experimentName) {
  experimentName = experimentName.toUpperCase();

  if(experimentName in experiments){
    return experiments[experimentName];
  }
  return null;
}

export function inExperiment(experimentName) {
  const experiment = getExperiment(experimentName);
  return Boolean(experiment);
}


export function getVariation(experimentName, variationName) {
  const experiment = getExperiment(experimentName);
  variationName = variationName.toUpperCase();
  const variationList = experiment && experiment.variations || [];

  for(var i = 0; i < variationList.length; ++i) {
    const variation = variationList[i];

    if (variation.name.toUpperCase() === variationName) {
      return variation;
    }
  }

  return null;
}

export function setVariation(experimentName, variationName, value) {
  let experiment = getExperiment(experimentName);
  if(!experiment){
    experiment = {variations: []};
    setExperiment(experimentName, experiment);
  }

  variationName = variationName.toUpperCase();
  const variationList = experiment && experiment.variations || [];

  let foundVariation;
  for(var i = 0; i < variationList.length; ++i) {
    foundVariation = variationList[i];

    if (foundVariation.name.toUpperCase() === variationName) {
      break;
    }
  }

  if(!foundVariation){
    foundVariation = {};
    variationList.push(foundVariation);
  }

  Object.assign(foundVariation, {name: variationName, value});
}

export function inVariation(experimentName, variationName, defaultValue = false) {
  let variation;
  if (inExperiment(experimentName)) {
    variation = getVariation(experimentName, variationName);
    return Boolean(variation && variation.value)
  }

  return Boolean(variation || defaultValue);
}

Object.assign(experiments, exports);

export default experiments;



// WEBPACK FOOTER //
// ./assets/es6/common/evite/experiments.es6